// extracted by mini-css-extract-plugin
module.exports = {"sellformTermsScroll":"_1jotM"};